import { render, staticRenderFns } from "./ShowCommentModal.vue?vue&type=template&id=5ade7610&scoped=true&"
import script from "./ShowCommentModal.vue?vue&type=script&lang=js&"
export * from "./ShowCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ade7610",
  null
  
)

export default component.exports